{
    "warning": "AVISO!",
    "message": "Não introduzas nem coles código que não compreendes.\nA utilização desta consola pode permitir que atacantes se façam passar por ti e roubem as tuas informações através de um ataque chamado Self-XSS."
}
